import React from 'react'
import { RecoilRoot } from 'recoil'
import { Provider as PaperProvider } from 'react-native-paper'
import { pt, registerTranslation } from 'react-native-paper-dates'
import { makeDateAdapterFactory, makeJwtAdapterFactory } from '@/main/adapters'
import { theme } from '@/presentation/styles'
import { Router, InstallButton, UserMenu } from '@/presentation/components'
import { makeGetRedesSociais, makeGetTheme, makePortalLogout, makeGetProspectConfigs, makeUpdatePassword } from '@/main/factories/usecases'
import '@/main/config/clarity'

registerTranslation('pt-BR', pt)
export default function App (): JSX.Element {
  const isHttps = window.location.protocol === 'https:'

  return (
    <RecoilRoot>
      <PaperProvider theme={theme}>
        <Router
          getRedesSociais={makeGetRedesSociais()}
          getTheme={makeGetTheme()}
          portalLogout={makePortalLogout()}
          getProspectConfigs={makeGetProspectConfigs()}
          updatePassword={makeUpdatePassword()}
          dateAdapter={makeDateAdapterFactory()}
          jwtAdapter={makeJwtAdapterFactory()}
        />
        {isHttps && <InstallButton />}
        <UserMenu />
      </PaperProvider>
    </RecoilRoot>
  )
}
